import { apiSlice } from "./apiSlice";

export const publicNoticeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPublicNotice: builder.mutation({
      query: (publicNoticeData) => ({
        url: "/publicNotices/createPublicNotice",
        method: "POST",
        body: publicNoticeData,
      }),
      invalidatesTags: ["PublicNotice"],
    }),

    deletePublicNotice: builder.mutation({
      query: (id) => ({
        url: `/publicNotices/deletePublicNotice/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PublicNotice"],
    }),

    updatePublicNotice: builder.mutation({
      query: ({ publicNoticeData, id }) => ({
        url: `/publicNotices/updatePublicNotice/${id}`,
        method: "PATCH",
        body: publicNoticeData,
      }),
      invalidatesTags: ["PublicNotice"],
    }),

    getAllPublicNotices: builder.query({
      query: ({ page = 1 } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        return {
          url: `/publicNotices/getAllPublicNotices?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["PublicNotice"],
    }),
    getPublicNoticeById: builder.query({
      query: (id) => ({
        url: `/publicNotices/getPublicNoticeById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreatePublicNoticeMutation,
  useUpdatePublicNoticeMutation,
  useDeletePublicNoticeMutation,
  useGetAllPublicNoticesQuery,
  useGetPublicNoticeByIdQuery,
} = publicNoticeApi;
